import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { api } from '../utils'
import useTrans from './useTrans'
import { buildAltriCostiFromCarrello } from '../containers/crea-offerta'

export default function useCreateOffertaUtils() {
  const [loghi, setLoghi] = useState()
  const [loading, setLoading] = useState()
  const [markupFields, setMarkupFields] = useState()
  const CreaOfferta = useSelector((state) => state?.creaofferta)
  const dispatch = useDispatch()
  const t = useTrans()

  const fetchLoghi = () => {
    setLoading(true)
    api
      .get('/loghi-offerte/')
      .then((res) => {
        setLoading(false)
        setLoghi(res?.data)
      })
      .catch((err) => {
        setLoading(false)
        console.log(err)
      })
  }

  const fetchMarkup = async () => {
    setLoading(true)
    const res = await api.get('/markup-offerte/').catch((err) => {
      setLoading(false)
      console.log(err)
    })

    setLoading(false)
    res?.data && setMarkupFields(res?.data)
    return res?.data
  }

  const initializeArticoliFromCart = (carrello, idOfferta = null, hash = null) => {
    let params = ''
    if (idOfferta && hash) {
      params += hash
      params += `&idOfferta=${idOfferta}`
    }

    api.get('/loghi-offerte/' + (params ? params : '')).then((res) => {
      dispatchCarrelloToStore(
        carrello,
        res?.data?.filter((logo) => logo?.logo === carrello?.logo)?.[0]?.id
      )
    })
  }

  const dispatchCarrelloToStore = (carrello, logo) => {
    dispatch({
      type: 'INIT_ARTICOLI_FROM_FETCHED',
      payload: {
        logoId: logo || null,
        carrello: carrello,
        altri_costi: buildAltriCostiFromCarrello(carrello),
      },
    })
  }

  const initializeArticoliFromCartForPdf = (carrello, idOfferta = null, hash = null) => {
    let params = ''
    if (idOfferta && hash) {
      params += hash
      params += `&idOfferta=${idOfferta}`
    }

    dispatchCarrelloToStore(carrello)
  }

  const getMailTo = (offerta) => {
    const subject = t('Preventivo')
    const body = 'Pdf offerta: ' + offerta?.pdf
    return `mailto:?subject=${subject}&body=${body}`
  }

  return {
    initializeArticoliFromCartForPdf,
    initializeArticoliFromCart,
    loghi,
    fetchLoghi,
    loading,
    markupFields,
    fetchMarkup,
    getMailTo,
  }
}
